import { RootState } from 'rootReducer';

export const roleSelector = (state: RootState) => state.authModuleReducer.authReducer.role;
export const authSelector = (state: RootState) => state.authModuleReducer.authReducer;
